import Axios from 'axios';
import cookie from 'react-cookies';
import getApiBaseUrl from './baseUrl';

const AxiosInstance = Axios.create({
  baseURL: getApiBaseUrl(),
});

AxiosInstance.interceptors.request.use(
  // Add any headers or other config options you want here
  (config) => {
    const tenantHost =
      typeof window !== 'undefined' && window.location
        ? window.location.host
        : null;
    const accessToken = cookie.load('token');
    const tokenValue =
      typeof accessToken === 'string'
        ? accessToken
        : typeof accessToken === 'object'
        ? accessToken?.token
        : null;
    const modifiedConfig = { ...config };
    modifiedConfig.headers = {
      ...(modifiedConfig.headers || {}),
      ...(tenantHost ? { 'x-tenant-host': tenantHost } : {}),
    };

    if (tokenValue) {
      modifiedConfig.headers = {
        ...(modifiedConfig.headers || {}),
        token: tokenValue,
        Authorization: `Bearer ${tokenValue}`,
      };
    }
    return modifiedConfig;
  },
);

export default AxiosInstance;
